import { z } from "zod";

export const agentActorSchema = z
    .object({
        actorId: z.string().min(1),
        role: z.enum(["user", "operator", "system", "agent"]),
        displayName: z.string().min(1).optional(),
    })
    .strict();

export type AgentActor = z.infer<typeof agentActorSchema>;

export const identifierSchema = z
    .string()
    .min(1)
    .max(128)
    .regex(/^[a-z0-9][a-z0-9._-]*$/);

export const digestSchema = z.string().regex(/^sha256:[a-f0-9]{64}$/);

export const jsonValueSchema = z.json();

export const jsonObjectSchema = z.record(z.string(), jsonValueSchema);

export const jsonSchemaSchema = z.record(z.string(), jsonValueSchema);

export type JsonValue = z.infer<typeof jsonValueSchema>;
export type JsonObject = z.infer<typeof jsonObjectSchema>;
export type JsonSchema = z.infer<typeof jsonSchemaSchema>;
